import { useMutation, useQueryClient } from "react-query";
import { AxiosInstance } from "axios";
import { useHistory } from "react-router";
import { useContext } from "react";

import { useClient } from "utils/client";
import { FormCb } from "components/Risk/formdata";
import { ControlContext } from "context/Controls";
import { orZero } from "components/Backoffice/Risk/Create";
import { useTranslation } from "react-i18next";

const updateRiskTemplate = async (
  client: AxiosInstance,
  { risk, mitigations }: FormCb,
  riskId: string
) => {
  const updatedRisk = {
    ...risk,
    resource_id: riskId,
    impact: orZero(risk.impact),
    people_count: orZero(risk.people_count),
    duration: orZero(risk.duration),
    probability: orZero(risk.probability),
    detectability: orZero(risk.detectability),
    mitigations: mitigations.map((mitigation) => ({
      ...mitigation,
      impact: orZero(mitigation.impact),
      people_count: orZero(mitigation.people_count),
      duration: orZero(mitigation.duration),
      probability: orZero(mitigation.probability),
      detectability: orZero(mitigation.detectability),
    })),
    assessment: {
      impact: orZero(risk.impact),
      people_count: orZero(risk.people_count),
      duration: orZero(risk.duration),
      probability: orZero(risk.probability),
      detectability: orZero(risk.detectability),
    },
  };

  await client.put(`/risk-templates/${riskId}`, {
    payload: updatedRisk,
  });

  return risk;
};

export const useUpdateRiskTemplateForEdit = (riskTemplateId: string) => {
  const client = useClient();
  const history = useHistory();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  const { mutate } = useMutation(
    async (v: FormCb) => await updateRiskTemplate(client, v, riskTemplateId),
    {
      onError: (e) =>
        displayNotification!(
          "Error updating Risk Template",
          (e as Error).message,
          "error"
        ),
      onSuccess: (newRisk) => {
        queryClient.refetchQueries(["riskTemplates"]);
        queryClient.refetchQueries(["riskTemplate", riskTemplateId]);

        history.push(`/risk-templates`);

        displayNotification!(t("notification.saving.generic_success"), "");
      },
    }
  );

  return mutate;
};
